// extracted by mini-css-extract-plugin
export default {"mainContainer":"customNode_mainContainer__0GCWJ"};